<script>
  import { onDestroy, onMount } from "svelte"
  import { links } from "svelte-routing"
  import { globalHistory } from "svelte-routing/src/history"
  import { user } from "../stores/User"

  let pathname = window.location.pathname
  let unsub
  let navigationOpen = false

  onMount(() => {
    unsub = globalHistory.listen(({ location }) => {
      pathname = location.pathname
    })
  })

  onDestroy(() => {
    if (unsub) unsub()
  })
</script>

<aside class="d-flex flex-column flex-shrink-0 p-5 bg-white sidebar border">
  <div class="navbar  p-0">
    <a
      href="/inicio"
      class="d-flex align-items-center fg-body text-decoration-none"
      use:links
    >
      <img
        src="/DOMAWARE-APPS-SBI.svg"
        alt="SBI Logo"
        class="me-3"
        style="height: 38px;"
      />
    </a>
    <button
      class="btn-icon navbar-toggler md:d-none"
      type="button"
      on:click={() => (navigationOpen = !navigationOpen)}
      aria-controls="sidebarNavigation"
      aria-expanded={navigationOpen}
      aria-label="Mostrar u ocultar navegación"
    >
      <span class="navbar-toggler-icon" aria-hidden="true" />
    </button>
  </div>

  <div
    class="{navigationOpen ? 'd-flex' : 'd-none'} md:d-flex flex-column flex-grow-1"
    id="sidebarNavigation"
  >
    <ul class="nav nav-pills nav-pills-vertical mt-7 mb-auto gap-1" use:links>
      {#if $user.permisos.includes("crm")}
        <li class="nav-item">
          <a
            href="/crm"
            class="nav-link fg-body fg-secondary"
            class:active={pathname.includes("/crm")}
          >
            <i class="bi bi-person-lines-fill me-3" aria-hidden="true" />
            CRM
          </a>
        </li>
      {/if}

      {#if $user.permisos.includes("persona")}
        <li class="nav-item">
          <a
            href="/persona"
            class="nav-link fg-body fg-secondary"
            class:active={pathname.includes("/persona")}
          >
            <i class="bi bi-person-vcard-fill me-3" aria-hidden="true" />
            Persona
          </a>
        </li>
      {/if}

      {#if $user.permisos.includes("empresa")}
        <li class="nav-item">
          <a
            href="/empresa"
            class="nav-link fg-body fg-secondary"
            class:active={pathname.includes("/empresa")}
          >
            <i class="bi bi-buildings-fill me-3" aria-hidden="true" />
            Empresa
          </a>
        </li>
      {/if}

      {#if $user.permisos.includes("masivo")}
        <li class="nav-item">
          <a
            href="/masivo"
            class="nav-link fg-body fg-secondary"
            class:active={pathname === "/masivo"}
          >
            <i class="bi bi-stack me-3" aria-hidden="true" />
            Masivo
          </a>
        </li>
      {/if}

      {#if $user.permisos.includes("reporte")}
        <li class="nav-item">
          <a
            href="/reporte"
            class="nav-link fg-body fg-secondary"
            class:active={pathname === "/reporte"}
          >
            <i class="bi bi-bar-chart-fill me-3" aria-hidden="true" />
            Reporte
          </a>
        </li>
      {/if}

      {#if $user.permisos.includes("filtro")}
        <li class="nav-item">
          <a
            href="/filtro"
            class="nav-link fg-body fg-secondary"
            class:active={pathname === "/filtro"}
          >
            <i class="bi bi-funnel-fill me-3" aria-hidden="true" />
            Filtro
          </a>
        </li>
      {/if}

      {#if $user.permisos.includes("configuracion")}
        <li class="nav-item">
          <a
            href="/configuracion"
            class="nav-link fg-body fg-secondary"
            class:active={pathname === "/configuracion"}
          >
            <i class="bi bi-gear-fill me-3" aria-hidden="true" />
            Configuración
          </a>
        </li>
      {/if}
    </ul>

    <hr />

    <p class="mb-1 px-3 small fg-secondary">
      <i class="bi bi-buildings me-1" aria-hidden="true" />
      {$user.razon_social}
    </p>
  </div>
</aside>

<style>
  .sidebar {
    width: 240px;
    min-height: 100vh;
  }

  .nav-pills {
    --bs-nav-link-justify: flex-start;
    --bs-nav-pills-padding: 0;
    --bs-nav-pills-bg: transparent;
    --bs-nav-pills-link-border-radius: var(--bs-radius-5);
  }

  .nav-link.active {
    color: var(--dw-text-inverse) !important;
  }

  @media (max-width: 767.98px) {
    .sidebar {
      width: 100%;
      min-height: auto;
    }
  }
</style>
